var _span;
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import { StickyContainerContext } from '../StickyContainer/StickyContainer.js';

/**
 * The StickyTrigger will toggle the sticky context provided by the StickyWrapper component based on the event binding provided
 **/
import { jsx as _jsx } from "react/jsx-runtime";
const ComponentWithContext = Component => props => /*#__PURE__*/_jsx(StickyContainerContext.Consumer, {
  children: _ref => {
    let {
      toggleSticky,
      onLoadHandled
    } = _ref;
    return /*#__PURE__*/_jsx(Component, {
      ...props,
      onLoadHandled: onLoadHandled,
      toggleSticky: toggleSticky
    });
  }
});
function StickyTrigger(props) {
  const {
    children = _span || (_span = /*#__PURE__*/_jsx("span", {})),
    showOnLeave,
    hideOnLeave,
    hideOnEnter,
    showOnEnter,
    onEnter = () => {},
    onLeave = () => {},
    instance = 'one'
  } = props;
  const {
    ref,
    entry
  } = useInView();
  const [previousPosition, setPreviousPosition] = useState(null);
  const [currentPosition, setCurrentPosition] = useState(null);
  const handleShowHideToggle = (prop, loc, show, elementInstance) => {
    if (prop === loc || prop === 'both') {
      props.toggleSticky({
        isSticky: {
          [elementInstance]: show
        }
      });
    }
  };

  /**
   * If the criteria matches and onLoadHandled is true, the context will get set to noLonger toggle the StickyElement
  **/
  const handleHideShowOnLeave = (onLeaveProp, show) => {
    const toggleSticky = showSticky => {
      props.toggleSticky({
        isSticky: showSticky,
        onLoadHandled: true
      });
    };
    if (onLeaveProp === 'top' && currentPosition === 'above') {
      toggleSticky(show);
    } else if (onLeaveProp === 'bottom' && currentPosition === 'below') {
      toggleSticky(show);
    } else if (onLeaveProp === 'both' && currentPosition !== 'inside') {
      toggleSticky(show);
    }
  };
  useEffect(() => {
    // handlePositionChange
    const isOnLoad = previousPosition === undefined && !props.onLoadHandled;
    if (isOnLoad) {
      if (showOnEnter && currentPosition === 'inside') {
        props.toggleSticky({
          isSticky: true,
          onLoadHandled: true
        });
      } else if (showOnLeave) {
        handleHideShowOnLeave(showOnLeave, true);
      } else if (hideOnLeave) {
        handleHideShowOnLeave(hideOnLeave);
      }
    } else {
      const waypoint = {
        previousPosition,
        currentPosition
      };
      if (previousPosition !== 'inside' && currentPosition === 'inside') {
        // handleWaypointEnter
        const hasConfig = showOnEnter || hideOnEnter;
        const isPositionAbove = previousPosition === 'above';
        if (hasConfig) {
          if (isPositionAbove) {
            handleShowHideToggle(showOnEnter, 'top', true, instance);
            handleShowHideToggle(hideOnEnter, 'top', false, instance);
          } else {
            handleShowHideToggle(showOnEnter, 'bottom', true, instance);
            handleShowHideToggle(hideOnEnter, 'bottom', false, instance);
          }
        }
        onEnter(waypoint);
      } else {
        // handleWaypointLeave
        const hasConfig = showOnLeave || hideOnLeave;
        const isPositionAbove = currentPosition === 'above';
        if (hasConfig) {
          if (isPositionAbove) {
            handleShowHideToggle(showOnLeave, 'top', true, instance);
            handleShowHideToggle(hideOnLeave, 'top', false, instance);
          } else {
            handleShowHideToggle(showOnLeave, 'bottom', true, instance);
            handleShowHideToggle(hideOnLeave, 'bottom', false, instance);
          }
        }
        onLeave(waypoint);
      }
    }
  }, [currentPosition, previousPosition]);
  useEffect(() => {
    if (entry?.boundingClientRect) {
      const copiedCurrentPosition = currentPosition;
      if (entry.isIntersecting) {
        setCurrentPosition('inside');
      } else if (entry.boundingClientRect.top > 0) {
        setCurrentPosition('below');
      } else {
        setCurrentPosition('above');
      }
      setPreviousPosition(copiedCurrentPosition);
    }
  }, [entry]);
  return /*#__PURE__*/_jsx("div", {
    "data-cmp": "stickyTrigger",
    ref: ref,
    children: children
  });
}
export default ComponentWithContext(StickyTrigger);